var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-carousel',{attrs:{"show-arrows-on-hover":"","delimiter-icon":"mdi-square","progress":""}},_vm._l((_vm.images),function(image,i){return _c('v-carousel-item',{key:i,attrs:{"src":image,"eager":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }